import { cloneDeep, merge } from '@helpers/data';

import { WithdrawalsSetBalanceReducer } from './types';
export const withdrawalsSetBalanceReducer: WithdrawalsSetBalanceReducer = (
  state,
  action
) => {
  const payload = action.payload;

  if (!state.withdrawalsDistributionBalanceItems) {
    return state;
  }

  const withdrawalsDistributionBalanceItems = merge(
    cloneDeep(state.withdrawalsDistributionBalanceItems),
    payload
  );

  return {
    ...state,
    withdrawalsDistributionBalanceItems,
  };
};
